import AlbumFolderLinkRequestRedirect from './AlbumFolderLinkRequestRedirect';

export default AlbumFolderLinkRequestRedirect;
